import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/feed/FeedClient.tsx");
